import ModalForm from "./pages/Products/ModalForm";

// export const BASE_URL = 'http://192.168.1.103:8000'
// export const BASE_URL = 'http://192.168.1.85:8000'

// Al momento de pushear dejar el web real habilitado
export const BASE_URL = process.env.REACT_APP_API_URL


function adaptedImageUrl(image_url) {
    if (image_url == null || image_url == '' || image_url == 'undefined') {
        return null;
    }

    try {
        if (!image_url.includes("http")) {
            image_url = 'https://seifrei-space.sfo3.digitaloceanspaces.com/seifrei/mediafiles/' + image_url;
        }
    }catch (exceptions){
        image_url=(URL.createObjectURL(image_url))
    }


    return image_url
}

export default adaptedImageUrl
